module.exports = __webpack_public_path__ + "img/icon-warning.58f9fcc9.svg";